import React from 'react';
import { User } from '../types';
interface DistributionPreviewProps {
  users: User[];
  distributionMethod: 'round-robin' | 'weighted';
  totalLeads?: number;
}
export function DistributionPreview({
  users,
  distributionMethod,
  totalLeads = 100
}: DistributionPreviewProps) {
  // Calculate percentages
  const activeUsers = users.filter(u => u.active);
  const segments = activeUsers.map(user => {
    let percentage = 0;
    if (distributionMethod === 'round-robin') {
      percentage = 100 / activeUsers.length;
    } else {
      // Normalize weights to 100%
      const totalWeight = activeUsers.reduce((sum, u) => sum + u.weight, 0);
      percentage = totalWeight > 0 ? user.weight / totalWeight * 100 : 0;
    }
    return {
      ...user,
      percentage,
      estimatedLeads: Math.round(percentage / 100 * totalLeads)
    };
  });
  // Colors for visualization
  const colors = ['bg-blue-500', 'bg-indigo-500', 'bg-purple-500', 'bg-pink-500', 'bg-rose-500', 'bg-orange-500', 'bg-amber-500', 'bg-emerald-500', 'bg-teal-500'];
  return <div className="w-full space-y-4" data-id="element-8">
      <div className="flex items-center justify-between text-sm text-gray-500 mb-2" data-id="element-9">
        <span data-id="element-10">Distribution Preview ({totalLeads} leads)</span>
        <span data-id="element-11">
          {distributionMethod === 'round-robin' ? 'Equal Split' : 'Weighted Split'}
        </span>
      </div>

      {/* Visual Bar */}
      <div className="h-4 w-full rounded-full overflow-hidden flex" data-id="element-12">
        {segments.map((segment, index) => <div key={segment.id} className={`${colors[index % colors.length]} h-full transition-all duration-500`} style={{
        width: `${segment.percentage}%`
      }} title={`${segment.name}: ${segment.percentage.toFixed(1)}%`} data-id="element-13" />)}
        {segments.length === 0 && <div className="w-full h-full bg-gray-200 flex items-center justify-center text-xs text-gray-500" data-id="element-14">
            No active users
          </div>}
      </div>

      {/* Legend */}
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mt-4" data-id="element-15">
        {segments.map((segment, index) => <div key={segment.id} className="flex items-center text-sm" data-id="element-16">
            <div className={`w-3 h-3 rounded-full mr-2 ${colors[index % colors.length]}`} data-id="element-17" />
            <div className="flex-1 truncate" data-id="element-18">
              <span className="font-medium text-gray-900" data-id="element-19">{segment.name}</span>
              <span className="ml-1 text-gray-500 text-xs" data-id="element-20">
                ({Math.round(segment.percentage)}% - ~{segment.estimatedLeads})
              </span>
            </div>
          </div>)}
      </div>
    </div>;
}